import { Icon } from '@chakra-ui/react';

export default function SFPauseFilled(props) {
  return (
    <Icon
      width='10px'
      height='13px'
      viewBox='0 0 10 13'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M1.27344 12.7266C0.59375 12.7266 0.234375 12.3672 0.234375 11.6797V1.03906C0.234375 0.359375 0.59375 0 1.27344 0H3.05469C3.73438 0 4.09375 0.328125 4.09375 1.03906V11.6797C4.09375 12.3672 3.73438 12.7266 3.05469 12.7266H1.27344ZM6.95312 12.7266C6.26562 12.7266 5.90625 12.3672 5.90625 11.6797V1.03906C5.90625 0.359375 6.26562 0 6.95312 0H8.72656C9.41406 0 9.76562 0.328125 9.76562 1.03906V11.6797C9.76562 12.3672 9.41406 12.7266 8.72656 12.7266H6.95312Z' />
    </Icon>
  );
}
